// Shared read-aloud script for device voice enrollment. The device records
// whatever ambient audio it hears during the window, so the passage is purely a
// UX aid: it gives the speaker enough varied, natural text to talk continuously
// for the full window, which produces a stronger voice embedding than silence
// or short bursts. It is never sent to the backend.
const ENROLLMENT_PASSAGE =
  "Thanks for setting up your voice profile. Read this aloud in your normal " +
  "speaking voice until the timer runs out. Picture describing your day to a " +
  "friend: the morning was bright and quiet, with a light breeze moving " +
  "through an open window. You made a cup of coffee, answered a few messages, " +
  "and mapped out the work ahead. Speak clearly and naturally, pausing between " +
  "sentences the way you normally would — there are no wrong words here, the " +
  "goal is simply to capture how you sound. If you reach the end before the " +
  "timer stops, start again from the top.";

export function ReadAloudPassage({
  state,
  remainingSec,
  totalSec,
}: {
  state: "waiting" | "recording";
  remainingSec: number;
  totalSec: number;
}) {
  const recording = state === "recording";
  const elapsedSec = Math.min(totalSec, Math.max(0, totalSec - remainingSec));
  const pct = totalSec > 0 ? Math.round((elapsedSec / totalSec) * 100) : 0;

  return (
    <div className="rounded-md border border-border bg-muted/40 p-3">
      <div className="mb-2 flex items-center justify-between gap-2">
        <span className="text-[12px] font-semibold tracking-wide text-foreground uppercase">
          Read this aloud
        </span>
        <span className="text-[12px] text-muted-foreground">
          {recording
            ? `Recording — keep reading (${remainingSec}s)`
            : "Get ready — your device is starting…"}
        </span>
      </div>
      <p className="text-[15px] leading-relaxed text-foreground">
        {ENROLLMENT_PASSAGE}
      </p>
      <div
        className="mt-3 h-1 overflow-hidden rounded-full bg-border"
        role="progressbar"
        aria-valuemin={0}
        aria-valuemax={totalSec}
        aria-valuenow={elapsedSec}
      >
        <div
          className="h-full rounded-full bg-primary transition-[width] duration-1000 ease-linear"
          style={{ width: recording ? `${pct}%` : "0%" }}
        />
      </div>
    </div>
  );
}
